import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import MobileWidgets from './MobileWidgets';
import WeatherWidgetList from './WeatherWidgetList';

const WeatherWidgets = () => {
  return (
    <>
      <Col xxl='6' xl='12' sm='12' className='xl-100 box-col-12'>
        <Card className='o-hidden'>
          <div className='weather-widget-two'>
            <CardBody>
              <Row>
                <MobileWidgets />
                <WeatherWidgetList />
              </Row>
            </CardBody>
          </div>
        </Card>
      </Col>
    </>
  );
};
export default WeatherWidgets;
